<template>
  <div>
    <v-row align="center">
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="contentSelection"
          :items="sectionList"
          dark
          hide-details
          label="Load Section"
          @change="updateSelection()" />
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn @click="contentSelection = ''; updateSelection()">Clear</v-btn>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn @click="deleteSelection()" :disabled="contentSelection === ''">Delete</v-btn>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn
          :color="sectionList.includes(section.replace(/ /g, '|').toLowerCase()) ? 'red' : 'green'"
          @click="saveContent()"
          :disabled="!invalidForm">
            {{ sectionList.includes(section.replace(/ /g, '|').toLowerCase()) ? 'Overwrite' : 'Create' }}        
        </v-btn>
      </v-col>
    </v-row>
    {{ invalidForm }}

    <v-form v-model="invalidForm">
      <v-row align="center">
        <v-col cols="4">
          <v-text-field v-model="section" :rules="sectionRules" label="Section Name" dark />
        </v-col>
        <v-col cols="4" />
        <v-col cols="2">
          <v-checkbox v-model="isComponent" label="Component" dark />
        </v-col>
        <v-col cols="12">
          <v-textarea v-if="!isComponent" v-model="content" dark label="Enter your content" />
          <v-select
            v-else
            v-model="componentSelection"
            :items="componentOptions"
            :rules="componentRules"
            dark
            label="Choose the component" />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invalidForm: true,
      isComponent: false,
      componentSelection: '',
      componentRules: [
        value => value !== '' || 'A component must be selected'
      ],
      section: '',
      sectionRules: [
        value => value !== '' || 'Section must be named',
        value => !value.includes('|') || 'No | allowed',
        value => !value.startsWith('table ') || 'Section name cannot begin with "table ".'
      ],
      content: '',
      contentSelection: ''
    };
  },
  props: {
    sections: {
      type: Object,
      required: true
    }
  },
  methods: {
    saveContent() {
      let sectionData = null;
      if (this.isComponent) {
        sectionData = {
          component: true,
          componentLocation: this.componentSelection
        };
      } else {
        sectionData = this.content;
      }

      const newSection = {
        section: this.section.replace(/ /g, '|').toLowerCase(),
        newContent: sectionData
      };
      this.$emit('updateSection', newSection);
    },
    updateSelection() {
      if (this.contentSelection !== '') {
        this.section = this.contentSelection.replace('|', ' ');
        if (this.sections[this.contentSelection].component) {
          this.isComponent = true;
          this.content = this.sections[this.contentSelection].componentLocation;
        } else {
          this.isComponent = false;
          this.content = this.sections[this.contentSelection];
        }
      } else {
        this.isComponent = false;
        this.section = '';
        this.content = '';    
      }
    },
    deleteSelection() {
      if (this.contentSelection !== '') {
        this.$emit('removeSection', this.contentSelection);
      }
    }
  },
  computed: {
    sectionList() {
      return Object.keys(this.sections).filter((keyword) => {
        if (!keyword.includes('table|')) {
          return keyword; 
        }
      });
    },
    componentOptions() {
      const componentOptions = [];
      const req = require.context('@/components/ceComponents/', false, /\.vue$/);
      req.keys().forEach((filename) => {
        const name = filename.split('.')[1].split('/')[1];
        componentOptions.push(name);
      });
      return componentOptions;
    }
  }
};
</script>

<style></style>
